import {fetch} from "utils/dataAccess";

export async function endMission(task, member) {
    const response = await fetch(`/w_m_s_tasks/end/${task.id}`, {
        method: "PATCH",
        headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
        body: JSON.stringify({
            member: "/members/"+member.id
        })
    });

    if (!response.ok) {
        throw new Error(`Failed to end mission with ID ${task.id} and member ${member.id} : ${response.statusText}`);
    }

    return response.json();
}
